// extracted by mini-css-extract-plugin
export default {"container":"fY-z","timeTop":"gY-z","timeCountdown":"hY-z","cta":"iY-z","disabled":"jY-z","product":"kY-z"};